import React, { Component } from "react";
// import Header from './Header.js'
// import Footer from './Footer';
import ProjPeopleContent from "./ProjPeopleContent";
/**
 * Research Scientist Component
 */
//import colors from './colors'
const data1 = {
  header: ["S. No. ", "Project", "Research Fellow"],
  rows: {
    row1:  [  "1",      "Spatial Flood Early Warning System",  "Ms. Peesapati Radha Manasa (RS & GIS)", ],
    row2:  ["", "", "Shri Devaraj R (RS & GIS)"],
    row3:  ["", "", "Ms. K Sindhu SRF (RS & GIS) (till 26-Apr-2021)"],
    row4:  ["", "", "Ms. Shraddha Madhav Moon (WR) (till 11-Oct-2019)"],
    row5:  [      "2",      "Regional Evaporative Flux Monitoring System", "Ms. Nalnajisa K A (RS & GIS)", ],
    row6:  ["", "",  "Ms. P Krishna Bhargavi (WR) (till 13-Mar-2020)"],
    row7:  ["", "", "Shri Nagendra Jaiganesh (RS & GIS) (till 17-Oct-2018)"],
    row8:  [      "3",      "Glacial Lake Outburst Flood (GLOF) Risk Assessment",   "Smt. Abina R (RS & GIS)"   ,  ],
    row9:  ["", "", "Shri Pamir Roy (RS & GIS) (till 18-Nov-2024)"],
    row10:  ["", "", "Smt. Maheshwari Ruhi Akilesh (RS & GIS) (till 30-Nov-2022)"],
    row11:  ["", "", "Smt. Sweta (WR) (till 13-Oct-2022)"],
    row12: [      "4",      "Spatial Snowmelt Runoff Estimation",   "Ms. Anabathula Rajeswari (WR) (till 04-Oct-2024)"],
    row13:  ["", "", "Ms. V Madhavi Supriya (RS & GIS) (till 10-Aug-2020)"],

    row14: [ "5",      "Operational Web-based National Hydrological Modelling System",  "Ms. Bukya Sreelaxmi (RS & GIS)",],   
    row15: ["", "",  "Shri S Anantha Krishnan (WR) (till 01-Mar-2019)", ],

    row16: ["6",      "Satellite Data Based Inputs for Irrigation Scheduling",   "Shri Sanjay Mallya (RS & GIS) (till 31-Dec-2024)"   ,    ],
    row17: ["", "","Shri Shobhan Mishra (WR) (till 29-Jan-2021)" ],


    row18: [ "7",      "Operational Hydrological Drought Services",   "Ms. Channa Satya Geetha Vimala (RS & GIS)"   ,    ],
    row19: ["", "","Shri K. Sai Santosh (WR) (till 30-Sep-2021)" ],
  
    row20: [ "8",      "Development of Web Enabled Hydrological Modelling in SWAT",   "Shri B. Satya Raj (WR) (till 13-Nov-2024)"   ,    ],
 
  },
}
const data = {
  header: ["S. No. ", "Project", "Research Scientist"],
  rows: {
    row1:  ["1", "Spatial Flood Early Warning System","Shri Vipul Anand (WR) (till 13-Jan-2025)"],
    row2:  ["", "","Ms. Rupal Budhbatti (WR) (till 06-May-2024)"  ],
    row3:  ["", "", "Shri Shubham Shaurabh (WR) (till 13-Sep-2021)"],
    row4:  ["", "","Smt. Suchismita Subhadarsini  (RS & GIS) (till 22-Jan-2019)"],

    row5:  ["2", "Regional Evaporative Flux Monitoring System", "Smt. Sweta (WR)"],
    row6:  ["", "", "Ms. Taroob Bashir Naqash (WR) (till 16-Oct-2024)" ],
    row7:  ["", "", "Ms. P. Madhavi (WR) (till 07-Nov-2023)"],

    row8:  ["", "", "Shri Utkarsh Kumar (WR) (till 11-Jun-2018) ", ],
    
     
    row9:  ["3", "Glacial Lake Outburst Flood (GLOF) Risk Assessment", "Ms. J Sai Priya (WR)"],
    row10:  ["", "", "Ms. R Pallavi (WR) (till 15-Oct-2024) "],
    
    row11:  ["", "", "Ms. K. Naga Mounika (WR) (till 17-Jan-2024)"],
    row12:  ["", "", "Smt. Sweta (WR) (till 01-Dec-2023)"],
    row13: ["", "", "Shri Mamidala Revanth (WR) (till 19-Dec-2022)",],
    row14: ["", "", "Shri Ankit Gupta  (RS & GIS) (till 24-Feb-2022)"],
    row15:  ["", "", "Dr. Nibedita Guru  (WR) (till 04-Dec-2020)"],


    row16: ["4", "Spatial Snowmelt Runoff Estimation", "Shri Palai Manoj Kumar (WR)" ],
    row17: ["", "", "Shri P Gopi  (RS & GIS) (till 10-Oct-2022)"],
    row18: ["", "", " Dr. Shivam  (WR) (till 02-Aug-2019)"],

    row19: ["5","Operational Web-based National Hydrological Modelling System", "Ms. Deepshika Negi (WR)"  ],
    row20: ["", "", "Shri Nagesh Mishra (WR) (till 05-Aug-2024)"],
    row21: ["", "", "Shri E Arivoli (WR) (till 24-Mar-2023) "],

    row22: ["", "", "Shri S Visakh (RS & GIS) (till 06-Jun-2022)"],
    row23: ["", "", "Dr. Sushil Kumar Himanshu  (WR) (till 20-Aug-2018)"],

    row24: ["6","Satellite Data Based Inputs for Irrigation Scheduling","Dr. Sithara S (WR) (till 18-Sep-2024)" ],
    row25: ["", "", "Shri Ronald Singh  (RS & GIS) (till 18-Oct-2020)",],
    row26: ["", "", "Shri Bidhan Kumar Sahu  (WR) (till 18-Dec-2018) "],

    row27: ["7", "Operational Hydrological Drought Services",  "Ms. Asha Farsana M (WR)"  ],
    row28: ["", "", "Smt. Aloshree Choudhury  (RS & GIS) (till 30-Jun-2020)"],
    row29: ["", "","Shri Nitesh Patidar (WR) (till 08-Mar-2019)"],

    row30: ["8", "Development of Web Enabled Hydrological Modelling in SWAT",  "Shri B. Satya Raj (WR)"  ],
    row31: ["", "", "Dr. Amrutha Suresh (WR) (till 13-Sep-2024)"],

    row32: ["9","Water Information Systems Development & Dissemination", " Ms. Isha Pant (SW)",],
    row33: ["", "","Ms. B. Kalpana (SW)",],
    row34: ["", "","Shri K. Syamasundara Rao  (SW) (till 25-Aug-2021)",],
    row35: ["", "","Ms. Beryl Joylin  (SW) (till 30-Sep-2019)"],
    row36: ["", "", "Smt. Nalini Raghav (SW) (till 18-Apr-2019)"],
  },
  
  // {
  //   row1: [
  //     "1",
  //     "Spatial Flood Early Warning System",
  //     "Smt. Suchismita Subhadarsini  (RS & GIS) (till 22-Jan-2019)",
  //   ],
  //   row2: ["", "", "Sri. Shubham Shaurabh (WR) (till 13-Sep-2021)"],
  //   row3: [
  //     "2",
  //     "Regional Evaporative Flux Monitoring System",
  //     "Sri. Utkarsh Kumar (WR) (till 11-Jun-2018) ",
  //   ],
  //   row4: ["", "", "Sri. P Madhavi (WR) "],
  //   row5: [
  //     "3",
  //     "Glacial Lake Outburst Flood (GLOF) Risk Assessment",
  //     "Sri. Ankit Gupta  (RS&GIS)",
  //   ],
  //   row6: ["", "", "Dr. Nibedita Guru  (WR) (till 04-Dec-2020)"],
  //   row7: [
  //     "4",
  //     "Spatial snow melt runoff estimation",
  //     "Dr. Shivam  (WR) (till 02-Aug-2019)",
  //   ],
  //   row8: ["", "", "Sri. P Gopi  (RS & GIS)"],
  //   row9: [
  //     "5",
  //     "Operational Web-based National Hydrological Modelling System",
  //     "Dr. Sushil Kumar Himanshu  (WR) (till 20-Aug-2018)",
  //   ],
  //   row10: ["", "", "Sri. S Visakh (RS & GIS)"],
  //   row11: ["", "", "Sri. E Arivoli (WR) "],
  //   row12: [
  //     "6",
  //     "Satellite data based inputs for Irrigation Scheduling",
  //     "Sri. Ronald Singh  (RS&GIS)",
  //   ],
  //   row13: ["", "", "Sri. Bidhan Kumar Sahu  (WR) (till 18-Dec-2018) "],
  //   row14: [
  //     "7",
  //     "Operational hydrological drought services",
  //     "Sri. Nitesh Patidar (WR) (till 08-Mar-2019)",
  //   ],
  //   row15: ["", "", "Smt. Aloshree Choudhury  (RS & GIS) (till 30-Jun-2020)"],
  //   row17: [
  //     "8",
  //     "Bhuvan products & Services",
  //     "Sri. K. Syamasundara Rao  (SW) (till 25-Aug-2021)",
  //   ],
  //   row16: ["", "", "Ms. Beryl Joylin  (SW) (till 30-Sep-2019)"],
  //   row18: ["", "", "Smt. Nalini Raghav (SW) (till 18-Apr-2019)"],
  // },
};
export default class ResearchScientist extends Component {
  render() {
    return (
      <div
        style={{
          padding: "15px",
          boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
          overflowY: "auto",
        }}
        className="card"
      >
        <h3 style={{ textAlign: "center", color: "#002171" }}>
          Research Scientists
        </h3>
        {/* <h5 style={{textAlign:"right",color: "#002171",margin:"0px",padding:"0px"}}> *Note: Red color denotes Ex-Employees</h5> */}
        <div className="card-body" style={{width:"70vw",margin:"0 auto"}} >
          <ProjPeopleContent data={data} width="100%" />
        </div>
        <h3 style={{ textAlign: "center", color: "#002171" }}>
          Research Fellows
        </h3>
        {/* <h5 style={{textAlign:"right",color: "#002171",margin:"0px",padding:"0px"}}> *Note: Red color denotes Ex-Employees</h5> */}
        <div className="card-body" style={{width:"70vw",margin:"0 auto"}} >
          {/* <p style={{ textAlign: "right" }}>Note : </p> */}
          <ProjPeopleContent data={data1} width="50%" />
        </div>
      </div>
    );
  }
}
